import styled from 'styled-components';

export const InfoBlockContainer = styled.div`
  margin-bottom: 35px;
`;

export const LastInfoBlockContainer = styled.div`
  margin-bottom: 20px;
`;
